'use strict';
const angular = require('angular');
const {forEach, isArray} = angular;

//function Validator() {
//}
//
//Validator.prototype.constructor = Validator;
//
//Validator.prototype.validateConstraint = function (instance, propName) {
//};
//
//Validator.prototype.validateType = function (value, constraint) {
//};
//
//Validator.prototype.validateValue = function (value, constraint) {
//};

export function ValidationErrors() {
  Object.defineProperty(this, '__size', {
    writable: true,
    value: 0
  });
}

ValidationErrors.prototype.constructor = ValidationErrors;

ValidationErrors.prototype.$reset = function () {
  forEach(this, function (value, key) {
    this[key] = [];
  }, this);
  this.__size = 0;
};

ValidationErrors.prototype.$size = function () {
  return this.__size;
};

/**
 * @param {string} propertyName
 * @param {FieldError} error
 */
ValidationErrors.prototype.$addError = function (propertyName, error) {
  if (!this[propertyName]) {
    this[propertyName] = [];
  }
  sanitizeArguments(error.arguments);
  this[propertyName].push(error);
  this.__size++;
};

/**
 * @param {string} propertyName
 * @param {Array.<FieldError>} errors
 */
ValidationErrors.prototype.$addErrors = function (propertyName, errors) {
  if (isArray(errors)) {
    for (let i = 0; i < errors.length; i++) {
      this.$addError(propertyName, errors[i]);
    }
  }
};

ValidationErrors.prototype.toArray = function () {
  var array = [];
  forEach(this, function (value, key) {
    if (this[key].length) {
      array.push(this[key]);
    }
  }, this);

  return array;
};

function sanitizeArguments(args) {
  forEach(args, function (value, key) {
    args[key] = '' + value;
  });
}



// WEBPACK FOOTER //
// ./src/js/_libs/angular-domain/domain-properties/Validation.js